//    Copyright (c) 2012 Mathieu Turcotte
//    Licensed under the MIT license.
import BackoffStrategy from './strategy'

// Fibonacci backoff strategy.
export default class FibonacciBackoffStrategy extends BackoffStrategy {
  private backoffDelay_: number
  private nextBackoffDelay_: number
  
  constructor(options) {
    super(options)

    this.backoffDelay_ = 0
    this.nextBackoffDelay_ = this.getInitialDelay()
  }

  next_() {
    const backoffDelay = Math.min(this.nextBackoffDelay_, this.getMaxDelay())
    this.nextBackoffDelay_ += this.backoffDelay_
    this.backoffDelay_ = backoffDelay
    return backoffDelay
  }

  reset_() {
    this.nextBackoffDelay_ = this.getInitialDelay()
    this.backoffDelay_ = 0
  }
}
